// Generated by purs version 0.14.5
"use strict";
var Box = require("../Box/index.js");
var TacoConstants = require("../TacoConstants/index.js");
var TacoTable_Styles = require("../TacoTable.Styles/index.js");
var addResourceTableWrapperStyles = Box.boxStyle([ new Box.Style(TacoTable_Styles.tableHoverStyles), new Box.FlexGrow(1), Box.FlexColumn.value, new Box.Position(Box.Relative.value), new Box.Selector(".__TacoTable", [ Box.MinHeight.create(new TacoConstants.CustomSize("auto")) ]), Box.Width.create(new TacoConstants.CustomSize("100%")), new Box.Border(TacoConstants.BorderLight.value), new Box.Height(new TacoConstants.CustomSize("0")) ]);
module.exports = {
    addResourceTableWrapperStyles: addResourceTableWrapperStyles
};
